import BasicDomainItems from "./BasicDomainItems";
import ExpertDomainItems from "./ExpertDomainItems";
import PrimaryGamesItems from "./PrimaryGamesItems";

const BasicDomainInfoConfirm = ({ fields, expertDomainChecks, viewMode, primaryGames, member }) => {

  const getCheckedExpertDomainItems = (checks) => {
    if (!checks) return '';
    let arr = [];
    for (let i = 0; i < checks.length; i++) {
	if (0 != checks[i]) arr.push(ExpertDomainItems[i]);
    }
    return arr.join(', ');
  };

  const getPrimaryGamesText = (pgNo) => {
      console.log('##### pgNo:' + pgNo);
    switch (pgNo) {
      case '1':
	  return PrimaryGamesItems[0];
      case '2':
	  return PrimaryGamesItems[1];
      case '3':
	  return PrimaryGamesItems[2];
      case '4':
	  return PrimaryGamesItems[3];
      case '11':
	  return PrimaryGamesItems[4];
      case '12':
	  return PrimaryGamesItems[5];
      case '13':
	  return PrimaryGamesItems[6];
      case '14':
	  return PrimaryGamesItems[7];
      case '21':
	  return PrimaryGamesItems[8];
      default:
          return '';
    }
  };

  return (
    <>
                <h3>診療科目</h3>
              <dl>
                <dt>ベーシック領域<span class="red">*</span></dt>
          <dd>{ BasicDomainItems[(viewMode ? member.basicDomain : fields.basicDomain) - 1]  } { 22 == (viewMode ? member.basicDomain : fields.basicDomain) ? '（' + (viewMode ? member.basicDomainOther : fields.basicDomainOther)  +　'）' : '' }&nbsp;</dd>
                <dt>エキスパート領域<span class="red">*</span></dt>
          <dd>{ getCheckedExpertDomainItems(viewMode ? member.expertDomains : expertDomainChecks) }&nbsp;</dd>
                <dt>主としてサポートしている競技の分類<span class="red">*</span></dt>
          <dd>{ getPrimaryGamesText(viewMode ? member.primaryGames : primaryGames) }&nbsp;</dd>
              </dl>
    </>
  );
}

export default BasicDomainInfoConfirm;
